<div class="modal-body">
    <button (click)="dismiss()" tabindex="-1" type="button" class="bootbox-close-button close" aria-hidden="true">×</button>
    <div class="bootbox-body">Sei sicuro di voler eliminare ?</div>
</div>
<div class="modal-footer">
    <button (click)="dismiss()"  tabindex="-1" type="button" class="btn btn-danger bootbox-cancel">No</button>
    <button (click)="delete()" tabindex="-1" type="button" class="btn btn-success bootbox-accept">sì</button>
</div>